import { Select } from "antd";
import { FC } from "react";

const SelectOrderStatusField: FC<any> = (props: any) => {
  return (
    <Select {...props}>
      <Select.Option key="new" >جدید</Select.Option>
      <Select.Option key="awaiting" >انتظار پرداخت</Select.Option>
      <Select.Option key="paid" >پرداخت شده</Select.Option>
      <Select.Option key="doing" >در حال انجام</Select.Option>
      <Select.Option key="done" >انجام شده</Select.Option>
      <Select.Option key="error" >خطا</Select.Option>
    </Select>
  )
}

export default SelectOrderStatusField
